export default "__VITE_ASSET__CWN_r8O2__"